<template>
  <v-app id="landing-page" :style="{ 'background-color': '#EEEEE7' }">
    <v-main class="mx-0 mt-0">
      <router-view />
    </v-main>

    <v-footer class="cookie-footer justify-center py-3">
    <a
      href="#configuracion-cookies"
      class="cookie-settings-link"
      @click.prevent="openCookieSettings"
    >
      Configuración de Cookies
    </a>
  </v-footer>
  </v-app>
</template>

<script>
import { mapState, mapActions, mapMutations } from "vuex";
import '@/assets/fonts/fonts.css';

export default {
  name: "App",
  
  components: {
  },

  data: () => ({
  }),

  computed: {
    ...mapState("auth", ["user", "access_token"]),
    ...mapState([
      "loading",
      "drawer",
      "dark",

      "colorFondo",
      "colorBarraFormulario",
      "colorAccent1",


      "colorFondo500",
      "colorFondo400",
      "colorFondo300",
      "colorFondo200",
      "colorFondo100",

      "colorFront500",
      "colorFront400",
      "colorFront300",
      "colorFront200",
      "colorFront100",

      "colorAccent2",
      "colorAccent1",
    ]),
     
  },

  mounted() {
    this.setDark(false);
    this.setThemeVerdeOpacoMostaza(true);
   // this.$router.push("/login");
  },

  methods: {
    ...mapActions("auth", ["logOut"]),
    ...mapMutations(["setDark", "setThemeVerdeOpacoMostaza", "setDrawer"]),
   
  
    _closeWin() {
      window.close();
    },

    _minimizeWin() {
      const { remote } = require("electron");
      remote.getCurrentWindow().minimize();
    },

    _changeDark() {
      this.setDark(!this.dark);
    },

    _maximizeWin() {
      const { remote } = require("electron");
      if (remote.getCurrentWindow().isMaximized) {
        window.resizeTo(800, 600);
      } else {
        remote.getCurrentWindow().maximize();
      }
    },

    openCookieSettings() {
      if (typeof window.revisitCkyConsent === 'function') {
        window.revisitCkyConsent()
      }
    },

  },
};

//background-image: url("./assets/fondo12.jpg");
</script>

<style>

* {
  text-transform: none !important;
  font-family: 'Mulish', sans-serif;
 
}


body, #landing-page {
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  position: relative;
  font-family: 'Mulish', sans-serif;
  
}

html {
  overflow: auto !important;
}

.v-data-table-header {
  background-color: grey;
}

.cky-btn-revisit-wrapper {
  display: none !important;
}

#landing-page .v-main__wrap > .v-container {
  height: auto !important;
}

</style>